const tourRoutePrefixes = [
  '/advances',
  '/associate-profiles',
  '/clients-request',
  '/invoices',
  '/payments',
  '/project-shift-auths',
  '/shifts'
]

const routeStartsWithOneOf = (path = '', prefixes = []) => prefixes.some(prefix => path.startsWith(prefix))

let vueTourLoaded = false
let vueTourPromise = null

export const loadVueTourPlugin = async Vue => {
  if (vueTourLoaded) {
    return
  }

  if (vueTourPromise) {
    return vueTourPromise
  }

  vueTourPromise = Promise.all([import('vue-tour'), import('vue-tour/dist/vue-tour.css')])
    .then(([vueTourModule]) => {
      Vue.use(vueTourModule.default || vueTourModule)
      vueTourLoaded = true
    })
    .finally(() => {
      vueTourPromise = null
    })

  return vueTourPromise
}

export const maybeLoadVueTourPlugin = (Vue, route = null) => {
  const path = route?.path || window?.location?.pathname || ''
  const fullPath = route?.fullPath || `${window?.location?.pathname || ''}${window?.location?.search || ''}`

  if (fullPath.includes('tour=') || routeStartsWithOneOf(path, tourRoutePrefixes)) {
    loadVueTourPlugin(Vue).catch(() => {})
  }
}
